import { SurveyData } from '@/constants';

import type { InsightsPageCopy } from '@/components/InsightsV2/MemberInsightsPage/types';

export const SELF_PULSE_EMPTY_DESCRIPTION =
  'A periodic survey asking you to self evaluate how you feel about your work and coaching. Beginning at the start of your coaching journey, see the progress and changes about every 6 months.';

export const COACH_MEMBER_INSIGHTS_COPY: InsightsPageCopy = {
  aiSummariesLabel: 'AI Summaries',
  heading: 'Insights',
  peerInsightsDescription:
    "Coach better by seeing feedback from your clients' coworkers. Great for new members, members that don't get formal feedback, want a promotion, or just finished a milestone and want to learn from the experience.",
  pulseCheckDescription:
    "Pulse Check is Mento's self-assessment member survey, used to identify growth areas and measure progress over time.",
  pulseCheckEmptyState:
    'Surveys are sent at the beginning of a member’s journey, then about every 6 months. You will be notified when your member completes their survey.',
  viewLabel: 'View',
};

export const SELF_INSIGHTS_COPY: InsightsPageCopy = {
  aiSummariesLabel: 'AI Summaries',
  heading: 'Insights',
  peerInsightsDescription: SurveyData.clientData.description,
  pulseCheckDescription:
    'A periodic survey that helps you reflect on how work, growth, and coaching are feeling. Revisit your past responses to compare changes over time.',
  pulseCheckEmptyState:
    'Pulse surveys are sent at the beginning of your journey, then about every 6 months. Your completed surveys will appear here.',
  viewLabel: 'View',
};
